import { useState } from "react";
import { PasswordHideIcon } from "../../Assets/icons/PasswordHideIcon";
import { PasswordShowIcon } from "../../Assets/icons/PasswordShowIcon";
import logo from "../../Assets/images/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { authService } from "../../services/authServices";
import { toast } from "react-toastify";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");

  const validateForm = () => {
    const newErrors = {};
    if (!formData.newPassword.trim()) {
      newErrors.newPassword = "Password is required";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }
    
    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    if (formData.confirmPassword !== formData.newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await authService.resetPassword(email, formData.newPassword);
      if (response.status === "ok" || response.code === 200) {
        navigate("/success");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message?.[0]?.detail;
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <a href="" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </a>
          </div>
          <div className="authcardmain">
            <div className="authcardheader">
              <span className="h_2 white-font fw-medium mb-3 d-inline-block">
                Reset Password
              </span>
              <p className="white-font fw-normal font-14 authcardsubtitle">
                At least 9 letters with uppercase and lowercase
              </p>
            </div>
            <form className="authform" onSubmit={handleSubmit}>
              <div className="form-group password-group position-relative mb-3 pb-1">
                <input
                  type={showNewPassword ? "text" : "password"}
                  name="newPassword"
                  value={formData.newPassword}
                  className="form-control"
                  placeholder="New Password"
                  onChange={handleInputChange}
                />
                <span
                  className="pswd-hide-show cursor-pointer"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <PasswordShowIcon /> : <PasswordHideIcon />}
                  {/* <PasswordShowIcon /> */}
                </span>
                {errors.newPassword && (
                  <span className="required-text">{errors.newPassword}</span>
                )}
              </div>
              <div className="form-group password-group position-relative mb-4">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  className="form-control"
                  placeholder="Confirm Password"
                  onChange={handleInputChange}
                />
                <span
                  className="pswd-hide-show cursor-pointer"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <PasswordShowIcon /> : <PasswordHideIcon />}
                  {/* <PasswordShowIcon /> */}
                </span>
                {errors.confirmPassword && (
                  <span className="required-text">{errors.confirmPassword}</span>
                )}
              </div>
              <button type="submit" className="btn-primary-custom w-100">
                Confirm Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
